import React, { createContext, useContext, useState, useEffect } from "react";
import Axios from "axios";

const ShelfContext = createContext();

export const ShelfProvider = ({ children }) => {
  const [shelves, setShelves] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  // 🔄 جلب كل الرفوف
  const fetchShelves = async () => {
    try {
      setIsFetching(true);
      const res = await Axios.get(
        `${process.env.REACT_APP_API_URL}/shelf/getShelves.php`
      );
      if (res.data.status === "success") {
        setShelves(res.data.shelves || []);
      } else {
        console.error("⚠️ فشل في جلب البيانات:", res.data.message);
      }
    } catch (err) {
      console.error("❌ فشل في جلب الرفوف:", err);
    } finally {
      setIsFetching(false);
    }
  };

  // 🗑️ حذف رف
  const deleteShelf = async (id) => {
    if (!window.confirm("هل أنت متأكد أنك تريد حذف هذا الرف؟")) return;

    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/shelf/deleteShelf.php?id=${id}`
      );

      if (res.data.status === "success") {
        // 🔥 احذف الرف مباشرة من الحالة بدون إعادة تحميل الصفحة
        setShelves((prev) => prev.filter((shelf) => shelf.id !== id));
        alert("تم حذف الرف بنجاح ✅");
      } else {
        alert(res.data.message || "فشل في حذف الرف ❌");
      }
    } catch (err) {
      console.error("❌ خطأ أثناء حذف الرف:", err);
      alert("حدث خطأ أثناء حذف الرف ❌");
    }
  };

  // ✏️ تحديث رف
  const updateShelf = async (shelfData) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/shelf/updateShelf.php?id=${shelfData.id}`,
        {
          name: shelfData.name,
          description: shelfData.description,
        }
      );

      if (res.data.status === "success") {
        // 🔥 حدث الرف مباشرة في الحالة بدون إعادة تحميل الصفحة
        setShelves((prev) =>
          prev.map((shelf) =>
            shelf.id === shelfData.id
              ? {
                  ...shelf,
                  name: shelfData.name,
                  description: shelfData.description,
                }
              : shelf
          )
        );
        return { success: true, message: res.data.message };
      }
    } catch (err) {
      console.error("❌ خطأ أثناء تحديث الرف:", err);
      return {
        success: false,
        message: err.response?.data?.message || "حدث خطأ أثناء التحديث",
      };
    }
  };

  useEffect(() => {
    fetchShelves();
  }, []);

  return (
    <ShelfContext.Provider
      value={{
        shelves,
        setShelves,
        isFetching,
        fetchShelves,
        deleteShelf,
        updateShelf,
      }}
    >
      {children}
    </ShelfContext.Provider>
  );
};

// ✅ هوك مخصص للاستخدام السهل
export const useShelfContext = () => useContext(ShelfContext);
